module.exports = __webpack_public_path__ + "static/media/sandclock_white.8309a368.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gifs/sandclock_white.gif
// module id = 717
// module chunks = 11